import { Wrench } from "lucide-react";
import { Reveal, Overline, IMG, scrollToHash } from "./shared";

const EXEMPLES = [
  "Petites réparations", "Travaux d'entretien", "Montage et remplacement de petits équipements",
  "Remise en état", "Petites rénovations", "Rafraîchissement de surfaces",
  "Réparations simples", "Travaux extérieurs", "Entretien d'espaces verts",
  "Petits travaux de paysagisme", "Débarras et évacuation",
];

const DOMAINES = ["Petites réparations", "Maintenance", "Rafraîchissement", "Petites rénovations", "Remise en état", "Extérieurs"];

export const Travaux = () => (
  <section id="travaux" className="bg-nuit py-24 lg:py-36" data-testid="travaux-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-10">
      <div className="grid grid-cols-1 items-start gap-12 lg:grid-cols-2 lg:gap-20">
        <div>
          <Reveal>
            <Overline light>Travaux, réparations &amp; entretien</Overline>
            <h2 className="font-display mt-4 text-3xl font-medium leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
              Petits &amp; moyens travaux d'entretien
            </h2>
            <p className="mt-6 text-base leading-relaxed text-white/65">
              L'expérience de Steve Rosset, acquise au fil des années dans la construction, la
              rénovation, l'entretien et le paysagisme, permet de prendre en charge de nombreuses
              petites interventions — un vrai avantage pour l'entretien de votre bien.
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <div className="mt-6 flex flex-wrap gap-2">
              {DOMAINES.map((d) => (
                <span key={d} className="border border-lagoon/30 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.15em] text-lagoon">
                  {d}
                </span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.14}>
            <div className="mt-10 grid grid-cols-1 gap-x-8 gap-y-3 sm:grid-cols-2">
              {EXEMPLES.map((e) => (
                <div key={e} className="flex items-center gap-3 border-b border-white/10 pb-3">
                  <Wrench className="h-3.5 w-3.5 shrink-0 text-lagoon/70" />
                  <span className="text-sm text-white/80">{e}</span>
                </div>
              ))}
            </div>
            <p className="mt-8 text-xs leading-relaxed text-white/40">
              Les domaines réglementés nécessitant une autorisation particulière ne font pas partie des prestations proposées.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1} className="lg:sticky lg:top-28">
          <div className="group relative overflow-hidden">
            <img
              src="/assets/gallery/pose-cloisons-renovation-sion.webp"
              alt="Pose de plaques de plâtre — petits travaux de rénovation à Sion"
              loading="lazy"
              className="aspect-[4/5] w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-nuit/20" />
          </div>
          <p className="font-display mt-8 border-l-2 border-lagoon pl-6 text-xl font-medium leading-snug text-white sm:text-2xl">
            Moins d'intervenants, plus de simplicité.
          </p>
          <p className="mt-4 pl-6 text-sm leading-relaxed text-white/55">
            Pour de nombreuses petites interventions, contactez directement Rosset Conciergerie &amp; Services
            plutôt que de rechercher un nouvel artisan pour chaque problème.
          </p>
          <a
            href="/contact"
            data-testid="travaux-cta-devis"
            className="ml-6 mt-8 inline-block rounded-full bg-lagoon px-7 py-4 text-sm font-bold uppercase tracking-[0.12em] text-nuit transition-colors duration-300 hover:bg-white"
          >
            Décrire mon besoin
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
